export default __webpack_public_path__ + "static/media/geoclaim.66e74db6.png";